import { endPoint } from './base.config';

export const voucherPaymentsAuth = {
  add: endPoint + 'voucherPaymentsAuths',
  updateByBasketUUID: endPoint + 'voucherPaymentsAuths/updateByBasketUUID',
  getAuthStatusByBasketUUID: endPoint + 'voucherPaymentsAuths/getAuthStatusByBasketUUID',
};
